import { Row, Col, Button, Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import BannerImage from "../../assets/cmc.jpg";
import ViewMoreIcon from "../../assets/right-arrow.svg";
import "./Memory.css";
import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";

function ViewMoreMemory() {
  const [memorys, setMemory] = useState([]);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    fetchMemory();
  }, []);

  const fetchMemory = (props) => {
    setLoading(true)
    axios
      .get(baseUrl + "/app/memory/")
      .then(async (response) => {
        setMemory(response.data);
        setLoading(false)
        console.log("huyyaMemory: " + JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
        setLoading(false)
      });
  };

  return (
    <section className="memory" id="memory">
      {memorys && (
        <Container>
          <div className="memory-content">
            <div className="section-title pt-5">
              In Loving
              <br />
              memory
            </div>
            { loading ?  <div className="loader"><Spinner className="loading-color"/></div>:  <Row className="memory-row">
              {memorys &&
                memorys.map((item, index) => {
                  return (
                    <>
                      <Col
                        lg={4}
                        className="memory-image pt-3 d-flex align-items-center flex-column"
                        key={index}
                      >
                        <div class="oval-shape">
                          <img src={item.image} className="w-100" />
                        </div>
                        <div className="memory-name py-3">{item.name}</div>
                      </Col>
                    </>
                  );
                })}
            </Row> }
           
          </div>
        </Container>
      )}
    </section>
  );
}

export default ViewMoreMemory;
